export default {
    userInfo: state => state.user.userInfo,
    getPerms: state => state.user.perms,
    getRoutes: state => state.user.routes,
    systemInfo: state => state.system.systemInfo,
};
